import React from 'react';
import DedicatedDevelopers from '../common/dedicated-developers';
type Props = {
    title: string;
    bg: string;
    children: any;
};

const TechnologyFaq: React.FC<Props> = ({ title, bg, children }) => {
    return (
        <div className="section-py bg-[#F8F9FB] dark:bg-black dark:!pb-0">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12 pb-30">
                    <div className="lg:col-span-12">
                        <p
                            className="text-primary mb-2.5 fs-lg fw-700 dark:text-primary"
                            data-aos="fade-up"
                            data-aos-duration="700"
                            data-aos-delay="200"
                        >
                            Explore
                        </p>
                        <h2 className="mb-0 dark:text-white" data-aos="fade-up" data-aos-duration="700" data-aos-delay="100">
                            {title}
                        </h2>
                    </div>
                </div>
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-8">{children}</div>
                    <div className="lg:col-span-4">
                        <DedicatedDevelopers
                            path={'/img/jainam-shah.webp'}
                            height={100}
                            width={100}
                            alt="Developers"
                            title="Developers"
                            modelTittle="Dedicated Developers?"
                            url={'contact-us'}
                            bg={bg}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TechnologyFaq;
